import React from 'react';

interface Props {
  zIndex?: number;
  onClick?: () => void;
}

const Overlay: React.FC<Props> = ({ zIndex, onClick }) => {
  return (
    <button
      data-testid="overlay"
      className="fixed left-0 top-0 m-0 h-screen w-screen cursor-pointer appearance-none border-none bg-gray-400/30 p-0 dark:shadow-[8px_0_20px_4px_rgba(255,255,255,0.10)]"
      style={{ zIndex: zIndex ?? 600 }}
      onClick={onClick}
      type="button"
    />
  );
};

export default Overlay;
